import React from 'react'
import {MdDirections, MdSchedule} from 'react-icons/md'
import Button from '@components/V3/Button'

import {Store as StoreType} from '../useStoreLocator.main'

export interface Props {
  store: StoreType
  selected: boolean
  selectStore: () => void
}

export default function Store(props: Props) {
  const {store} = props
  return (
    <div className="rounded-lg bg-gray-50 p-5 border space-y-5">
      <div className="font-bold text-lg">
        <h3>{store.name}</h3>
      </div>
      {store.distanceToAddress ? (
        <div className="text-sm">Estas a {store.distanceToAddress}km del local</div>
      ) : null}
      <div className="space-y-2">
        <div className="flex space-x-2 items-center">
          <MdDirections className="h-4 w-4" />
          <a
            className="text-sm text-gray-900 underline"
            href={
              store.address.location
                ? `https://maps.google.com?q=${store.address.location.lat},${store.address.location.lng}`
                : '#'
            }
            target="_blank"
            rel="noreferrer">
            {store.address.address}, {store.address.addressSecondary}
          </a>
        </div>
        <div className="flex space-x-2 items-center">
          <MdSchedule className="h-4 w-4" />
          <span className="text-sm">
            {store.reservationsHumanSchedule ? (
              <span>
                {store.reservationsHumanSchedule
                  .map(schedule => `${schedule.days}, ${schedule.schedule}`)
                  .join('. ')}
              </span>
            ) : null}
          </span>
        </div>
      </div>
      <div className="space-x-2">
        <Button disabled={props.selected} onClick={() => props.selectStore()}>
          Ver en el mapa
        </Button>
        <Button primary to={`/reservas/${store._id}`}>
          Reservar mesa
        </Button>
      </div>
    </div>
  )
}
